import clsx from 'clsx';
import { useState } from 'react';
import { SvgIcon } from '../../../../common/components/SvgIcon';
import { PANEL_EXPANDED_PROPERTY } from '../../../../common/constants';
import { useSgwtTranslation } from '../../../../common/i18n';
import { useBotConversation } from '../../shared/BotConversationContext';

interface ChatHeaderProps {
  onClose: () => void;
  onGoBack: () => void;
  onResize: (expanded: boolean) => void;
}

export const ChatHeader = ({ onClose, onGoBack, onResize }: ChatHeaderProps) => {
  const { translate } = useSgwtTranslation();
  const { panelDisplayed, changePanelDisplayed, startNewConversation, isEmbeddedInHelpCenter } = useBotConversation();
  const [expanded, setExpanded] = useState(localStorage.getItem(PANEL_EXPANDED_PROPERTY) === 'true');

  const goBack = () => {
    if (panelDisplayed === 'history') {
      changePanelDisplayed('conversation');
    } else {
      onGoBack();
    }
  };

  const handleResize = () => {
    const newExpanded = !expanded;
    setExpanded(newExpanded);
    localStorage.setItem(PANEL_EXPANDED_PROPERTY, newExpanded.toString());
    onResize(newExpanded);
  };

  return (
    <div
      className={clsx(
        'sgwt-chatbot-header card-header d-flex align-items-center justify-content-between p-12px w-100 bg-lvl1 bg-opacity-75 bg-blur',
        {
          'position-absolute': isEmbeddedInHelpCenter,
        },
      )}
      style={{ zIndex: 2 }}
    >
      <div className="button-group">
        {(isEmbeddedInHelpCenter || panelDisplayed === 'history') && (
          <button type="button" className="btn btn-flat-secondary btn-icon btn-lg" onClick={goBack}>
            <SvgIcon type="arrow_back" />
          </button>
        )}
        {isEmbeddedInHelpCenter && (
          <button type="button" className="btn btn-link sgwt-panel-expand-button px-0 mr-3 me-3 d-none d-md-inline-block" onClick={handleResize}>
            <i aria-hidden="true" className="sgwt-widgets-icon">
              <SvgIcon width={24} height={24} type={expanded ? 'fullscreen_exit' : 'fullscreen'} />
            </i>
          </button>
        )}
      </div>

      <span
        className="h5"
        style={{
          // Add padding to center the title regardless of number of buttons displayed
          paddingLeft: panelDisplayed === 'conversation' ? '40px' : '0',
        }}
      >
        {translate(`panel.${panelDisplayed}`)}
      </span>

      <div className="button-group">
        {panelDisplayed === 'conversation' && (
          <>
            <button
              type="button"
              className="btn btn-flat-secondary btn-icon btn-lg"
              onClick={startNewConversation}
              title={translate('create.conversation')}
            >
              <SvgIcon type="add_comment" />
            </button>
            <button
              type="button"
              className="btn btn-flat-secondary btn-icon btn-lg"
              onClick={() => changePanelDisplayed('history')}
              title={translate('panel.history')}
            >
              <SvgIcon type="history" />
            </button>
          </>
        )}
        {isEmbeddedInHelpCenter && (
          <button type="button" className="btn btn-flat-secondary btn-icon btn-lg" onClick={onClose}>
            <SvgIcon type="close" />
          </button>
        )}
      </div>
    </div>
  );
};
